import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import printIcon from '../../assets/icons/print.svg';
import documentDownloadIcon from '../../assets/icons/documents-downloadall-small-icon.svg';
import s from './PageActions.module.scss';

/**
 * page actions component
 * @returns {undefined}
 */
function PageActions({ intl, download }) {
  return (
    <span className={s.pageActionsContainer}>
      <button
        type="button"
        className={`btn btn-sm ${s.printButtonImprint}`}
        onClick={() => window.print()}
        title={intl.formatMessage({ id: 'printSite' })}
      >
        <img src={printIcon} alt={intl.formatMessage({ id: 'printSite' })} />
      </button>
      <a href={download}>
        <button
          type="button"
          className={`btn btn-sm ${s.downloadButtonImprint}`}
          title={intl.formatMessage({ id: 'downloadPDF' })}
        >
          <img
            src={documentDownloadIcon}
            alt={intl.formatMessage({ id: 'downloadPDF' })}
          />
        </button>
      </a>
    </span>
  );
}

PageActions.propTypes = {
  intl: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  download: PropTypes.string.isRequired,
};

export default injectIntl(PageActions);
